module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-It.be0ed2bb.otf";